import { cn } from 'lib/utils';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import Button from '../buttons/button';

const TabButton = forwardRef(({ active, className, ...props }, ref) => {
  return (
    <Button
      {...props}
      className={cn(className, active && `button-active`)}
      ref={ref}
      theme="tab"
    />
  );
});

TabButton.displayName = 'TabButton';

TabButton.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
};

export default TabButton;
